import { CurrencyPipe, PercentPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory } from "common";
import { AccountAverage } from "../../../account/account.model";

@Injectable()
export class ProductAveragesListAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly percentPipe: PercentPipe,
  ) { }

  adaptListData = (data: AccountAverage[], index: number): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Product',
        displayedValue: data[index]?.product,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Average balance',
        displayedValue: this.formatCurrency(data[index]?.balance),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Average loan amount',
        displayedValue: this.formatCurrency(data[index]?.amount),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Average utilization',
        displayedValue: this.percentPipe.transform(data[index]?.utilization / 100, '1.2-2'),
      }),
    ]
  }

  private formatCurrency(value: number): string {
    return this.currencyPipe.transform(value, '$');
  }
}
